import "./ForgotPasswordForm.css";
import { useForm } from "react-hook-form";
import { BottomSection } from "../../BottomSection/BottomSection";
import { TopSection } from "../../TopSection/TopSection";
import { useState } from "react";
import axios from "axios";

export const ForgotPasswordForm = ({setForgotPasswordStep,setUserData}) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const [error ,setErrors] = useState('');
  const [loading,setLoading] = useState(false);
  const onSubmit = (data) => {
    setUserData(data)
    setLoading(true)
    axios.post('https://mfnj3t4tqm.us-east-1.awsapprunner.com/api/uloggedin/user/forgot-password',
      {
        phoneNumber : data?.mobileNumber
      }
    )
    .then((resp)=>{
      console.log(resp.data)
      setLoading(false);
      setForgotPasswordStep(1)
    })
    .catch((err)=>{
      setLoading(false);
      console.log("err",err?.response?.data)
      setErrors(err?.response?.data);
      setTimeout(()=>{
        setErrors('')
      },2000)
    })
    
  };

  console.log(watch("example")); // watch input value by passing the name of it
  return (
    <>
      <div className="forgot-pass-container">
        <TopSection />
        <form
          className="forgot-pass-middle-section"
          onSubmit={handleSubmit(onSubmit)}
        >
          <h2>Forgot Password ?</h2>
          <h5>Don’t worry we got you!</h5>
          <input
            type="text"
            id="fullName"
            name="fullName"
            placeholder="Full Name"
            {...register("fullName", { required: true })}
            className={`input-field ${errors.fullName ? "error-para" : ""}`}
          />
          <input
            type="number"
            id="mobileNumber"
            name="mobileNumber"
            placeholder="Mobile Number"
            onWheel={(e) => e.target.blur()}
            {...register("mobileNumber", { required: true })}
            className={`input-field ${errors.mobileNumber ? "error-para" : ""}`}
          />
          <button className="submit-btn" type="submit">
        {loading?'Loading...':  'Submit'}
          </button>
          {
            error &&
            <p style={{marginTop:10,fontSize:13,color:'red'}}>{error}</p>
          }
          <BottomSection />
        </form>

      </div>
    </>
  );
};
